<template>
  	<v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
        >
        <v-icon left dark>mdi-translate</v-icon>
          {{$t("lang")}}
        </v-btn>
      </template>
      
        <v-list>
          <v-list-item-group v-model="$i18n.locale">
            <v-list-item
              v-for="(item, index) in items"
              :value="item.code"
              :key="item.title"
              @click="setPath(item.code)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
    </v-menu> 
</template>

<script>
  export default {
  	name: 'LangSwitcher',

    data: () => ({
      items: [
        { title: 'English', code :'en' },
        { title: 'Français', code :'fr' },
        { title: 'العربية', code :'ar' },
      ],
      model:'en'
    }),

    methods: {
      setPath(newLang){
        this.$router.push({
          params : {lang : newLang}
        })
      }
    }
  }
</script>